module.exports = __webpack_public_path__ + "img/task_demo_cn.6cda66cb.png";